import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
    <motion.div
        className={className}
        initial={{ y, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
        viewport={{ once: true, margin: "-70px" }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ eyebrow, title, className = "", testId }) => (
    <div className={className}>
        <Reveal>
            <p className="text-xs sm:text-sm uppercase tracking-[0.35em] text-[#472500]/60 font-medium">
                {eyebrow}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                data-testid={testId}
                className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mt-4 text-[#472500]"
            >
                {title}
            </h2>
        </Reveal>
    </div>
);
